//@flow

import type { LngLat } from "Shared/LocationDescriptor/LocationDescriptor";

const LAYER_ID = 'you-are-here-person';


function FeatureFromLngLatZ(lngLat: LngLat, zLevel: number){
    return {
        type: "Feature",
        geometry: {
            type: "Point",
            coordinates: [ lngLat.lng, lngLat.lat ]
        },
        properties: {
            zLevel : zLevel
        }
    };
}

type YouAreHereProps = {
    map: Object,
    lngLat: LngLat,
    zLevel: number,
    zoom: number,
    bearing: number,
    pitch: number,
};


export default class YouAreHereLayer {
    options: YouAreHereProps;
    map: Object;


    constructor(options: YouAreHereProps){
        this.options = options;
        this.map = options.map;

        this.addCustomMarker(this.map).then( this.addLayer );
    }

    addCustomMarker(map: any): Promise<any>{

        let markerUrl;
        let pixelRatio = 2;
        if(window.devicePixelRatio === 1){
          markerUrl = require('./red-man-100@1x.png');
          pixelRatio = 1;
        }else{
          markerUrl = require('./red-man-100@2x.png');
        }

        return new Promise( function(resolve, reject){
            map.loadImage( markerUrl, function(error, loadedImage){
                if(error){
                    reject(error);
                }
                map.addImage(LAYER_ID, loadedImage, {pixelRatio: pixelRatio});
                resolve();
            });
        });

    }

    addLayer = () => {
        this.map.addLayer({
            id: LAYER_ID,
            source: {
                type: 'geojson',
                data: FeatureFromLngLatZ(this.options.lngLat, this.options.zLevel)
            },
            type: "symbol",
            layout: {
                  "text-field": "",
                  "icon-image": LAYER_ID,
                  "icon-offset": [0, -22],
                  "icon-size": {stops: [[17, 0.3] ,[22, 1]]},
                  "visibility": "visible",
                  "icon-allow-overlap": true
                },
                paint: {
                    "icon-opacity": 1,
                }
        });

        this.map.on('zlevel', this.redrawMarkerOpacity );
        this.redrawMarkerOpacity();

        this.map.layerEventHandler.on('click', LAYER_ID, this.onMarkerClick );
    }

    setLngLatZ(lngLat: LngLat, zLevel?: number) {
        this.options.lngLat = lngLat;
        this.options.zLevel = zLevel || this.options.zLevel;


        this.map.getSource(LAYER_ID).setData( FeatureFromLngLatZ(this.options.lngLat, this.options.zLevel) );
    }

    onMarkerClick = () => {
        this.map.setZLevel(this.options.zLevel);
        this.map.easeTo({center: this.options.lngLat, zoom: this.options.zoom, bearing: this.options.bearing, pitch: this.options.pitch });
    }

    redrawMarkerOpacity = () => {
        var offZ = this.map.getZLevel() !== this.options.zLevel;
        var outdoors = this.options.zLevel === 0;
        let opacity;

        if( outdoors ){
            opacity = 1;
        }else if(offZ){
            opacity = 0.3;
        }else {
            opacity = 1;
        }
        this.map.setPaintProperty(LAYER_ID, "icon-opacity", opacity);
    }
}


// WEBPACK FOOTER //
// src/kiosk/YouAreHereLayer/index.js